import PersonIcon from "@mui/icons-material/Person";
import Avatar from "@mui/material/Avatar";
import { useUserInfo } from "core/hooks/useUserInfo";
import { getAuthUrl } from "core/utils/getAuthUrl";
import { useTranslation } from "react-i18next";

export function UserAvatar({
  width,
  height,
  id,
}: {
  width?: number;
  height?: number;
  id?: string | undefined;
}) {
  const { t } = useTranslation("Fixhub", { keyPrefix: "Next:Core:UserAvatar" });
  const { data } = useUserInfo();
  const currentId = id ?? data?.id;
  if (!currentId) {
    return (
      <Avatar alt={t("altText")} sx={{ width, height }}>
        <PersonIcon />
      </Avatar>
    );
  }
  const src = getAuthUrl(`/api/account/profile-picture-file/${currentId}`);
  return <Avatar src={src} sx={{ width, height }} alt={t("altText")} />;
}
